import { params } from '../config.js';

let recaptchaScriptPromise = null;

function loadRecaptchaEnterpriseScript(siteKey) {
  if (window.grecaptcha && window.grecaptcha.enterprise) {
    return Promise.resolve(window.grecaptcha.enterprise);
  }

  if (recaptchaScriptPromise) {
    return recaptchaScriptPromise;
  }

  recaptchaScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.grecaptcha && window.grecaptcha.enterprise) {
        resolve(window.grecaptcha.enterprise);
        return;
      }

      reject(new Error('No se pudo inicializar reCAPTCHA Enterprise'));
    };
    script.onerror = () => reject(new Error('No se pudo cargar reCAPTCHA Enterprise'));
    document.head.appendChild(script);
  });

  return recaptchaScriptPromise;
}

export async function getRecaptchaEnterpriseToken(action) {
  if (!params.recaptcha_enterprise_enabled) {
    return null;
  }

  const siteKey = params.recaptcha_enterprise_site_key;
  if (!siteKey) {
    throw new Error('Falta recaptcha_enterprise_site_key en configuración de frontend');
  }

  const enterprise = await loadRecaptchaEnterpriseScript(siteKey);

  return new Promise((resolve, reject) => {
    enterprise.ready(() => {
      enterprise.execute(siteKey, { action })
        .then((token) => resolve(token))
        .catch((error) => reject(error));
    });
  });
}